import * as yup from 'yup';

export const validationScheme = yup
  .object()
  .shape({
    providerId: yup.number().required('shared.error.required'),
  })
  .required();
